import { Directive, HostListener, ElementRef, OnInit, OnChanges } from "@angular/core";
import { MoneyFormatPipe } from "../pipes/money-format.pipe";

@Directive({ 
    selector: '[MoneyFormat]', 
})

export class MoneyFormatDirective implements OnInit, OnChanges {

  private el: any;

  constructor(
    private elementRef: ElementRef,
    private moneyPipe: MoneyFormatPipe
  ) {
    this.el = this.elementRef.nativeElement;

  }

  ngOnInit() {
    this.el.value = isNaN(this.el.value) ? null :  this.moneyPipe.transform(this.el.value);
  }

  ngOnChanges() {
    this.el.value = isNaN(this.el.value) ? null : this.moneyPipe.transform(this.el.value); // opossite of transform
  }

  @HostListener("focus", ["$event.target.value"]) onFocus(value) {
    this.el.value = isNaN(value) ? null : this.moneyPipe.transform(value); // opossite of transform
  }

  @HostListener("blur", ["$event.target.value"]) onBlur(value) {
    this.el.value = isNaN(value) ? null :  this.moneyPipe.transform(value);
  }

}